module.exports = __webpack_public_path__ + "static/media/EventAbout-Icon.c09d1ded.svg";